import napStyles from './../nap.json'

const title = {
  fontSizeMobile: '24px',
  lineHeightMobile: '30px',
  fontWeight: '325',
  textTransform: 'none',
  fontSizeDesktop: '32px',
  lineHeightDesktop: '40px',
  color: napStyles.colors.PrimaryWhite
}

const cta = {
  fontWeight: '400',
  lineHeight: '17.5px',
  letterSpacing: '0.14px',
  color: napStyles.colors.PrimaryWhite
}

const paragraph = {
  fontWeight: '325',
  fontSize: '16px',
  lineHeight: '24px',
  color: napStyles.colors.PrimaryWhite
}

const loyaltyBanner = {
  title,
  cta,
  paragraph
}
export default loyaltyBanner
